import React from 'react';
import styles from './MyAccount.module.css';
import { useUserProfile } from '../../hooks/useUserProfile';


const UserData = () => {
  const { userData, isLoading, error } = useUserProfile();
  console.log(userData,'userData');
  

  if (isLoading) {
    return (
      <div className={styles.userInfo}>
        <div className={styles.loading}>Loading user data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.userInfo}>
        <div className={styles.error}>
          Failed to load user data. Please try again later.
        </div>
      </div>
    );
  }

  return (
    <div className={styles.userInfo}>
      <div className={styles.infoGroup}>
        <label>Name</label>
        <p>{userData?.user?.name || 'N/A'}</p>
      </div>
      <div className={styles.infoGroup}>
        <label>Email</label>
        <p>{userData?.user?.email || 'N/A'}</p>
      </div>
    </div>
  );
};
export default UserData